import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getHeaders } from '../../../lib/requests';
import Spinner from '../spinner';

const RouteModal = ({ isOpen, setIsOpen, selectRoute, value, isRequired = false }) => {
    const [routes, setRoutes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedRoute, setSelectedRoute] = useState(null);

    useEffect(() => {
        if (value && !isOpen) {
            setSelectedRoute(value);
        }

        if (!isOpen) return;

        const fetchRoutes = async () => {
            setIsLoading(true);
            try {
                const apiToken = localStorage.getItem('accessToken');
                const apiUrl = process.env.REACT_APP_API_URL;
                const params = searchQuery ? { name: searchQuery } : {};

                const response = await axios.get(`${apiUrl}/routes`, {
                    headers: getHeaders(apiToken),
                    params,
                });
                setRoutes(response.data.data);
            } catch (error) {
                console.error('Error fetching routes', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchRoutes();
    }, [isOpen, searchQuery, selectRoute]);

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    const handleSelectRoute = (route) => {
        selectRoute(route);
        setSelectedRoute(route);
        setIsOpen(false);
    };

    return (
        <>
            <div className="flex items-end space-x-4 mb-4">
                <div className="flex-1">
                    <label htmlFor="route_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Route Selected{isRequired && <span className="text-red-500">*</span>}
                    </label>
                    <input
                        type="text"
                        id="route_id"
                        name="route_id"
                        value={selectedRoute ? `${selectedRoute.name}` : ''}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Route"
                        readOnly
                        required={isRequired}
                    />
                </div>
                <div>
                    <button onClick={toggleModal} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                        Select Route
                    </button>
                </div>
            </div>

            {isOpen && (
                <>
                    <div className="fixed inset-0 bg-black bg-opacity-35 z-50"></div>

                    <div className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full">
                        <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                                <div className="flex justify-between items-start p-4 rounded-t border-b dark:border-gray-600">
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                        Select a Route
                                    </h3>
                                    <button onClick={toggleModal} className="text-gray-400 hover:bg-gray-200 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"></button>
                                </div>
                                <div className="p-4">
                                    <input
                                        type="text"
                                        placeholder="Search routes..."
                                        className="mb-4 bg-gray-50 border text-gray-900 text-sm rounded-lg block w-full p-2.5"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    {isLoading ? (
                                        <Spinner minHeight={100} />
                                    ) : (
                                        <ul className="max-h-60 overflow-y-auto">
                                            {routes.map((route) => (
                                                <li
                                                    key={route.id}
                                                    onClick={() => handleSelectRoute(route)}
                                                    className="cursor-pointer hover:bg-gray-100 p-2">
                                                    {route.name}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                <div className="flex items-center p-6 space-x-2 rounded-b dark:border-gray-600">
                                    <button onClick={toggleModal} className="bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 text-white font-medium rounded-lg text-sm px-5 py-2.5">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default RouteModal;
